import * as infiniteHits from './load_more_results';

window.ProductSetsSearch = {
  searchObject: {},
  _currentUser: null,

  initializeSearch(indexParams, searchParams, view, sortByIndices, currentUser, product_request_id) {
    this.indexParams = indexParams;
    this.searchParams = searchParams;
    this._currentUser = currentUser;
    this._initializeSearchObject();

    const widgets = [instantsearch.widgets.configure(this.searchParams)];

    if (product_request_id === undefined) {
      this._addWidgets(widgets, view, sortByIndices);
    } else {
      widgets.push(this._infiniteHitsWidget(currentUser));
    }

    this.searchObject.addWidgets(widgets);
    this.searchObject.start();
    infiniteHits.loadMoreResults();
    this.searchObject.on('render', function () {
      return $.cloudinary.responsive();
    });
  },

  _initializeSearchObject() {
    this.searchObject = SearchUtils.createInstantSearch(this.indexParams.appId, this.indexParams.key, this.indexParams.name);
  },

  _addWidgets(widgets, view, sortByIndices) {
    widgets.push(
      Widgets.clearAllWidget(),
      Widgets.statsWidget(),
      Widgets.searchBoxWidget('Search...'),
      ProductApprovalWidgets.stateWidget(),
      ProductWidgets.categoryWidget(),
      ProductWidgets.supplierWidget('supplier.name')
    );

    if (view === 'charts') {
      ProductApprovalWidgets.initAsyncHitsLoadingBreakdown();
      widgets.push(instantsearch.widgets.asyncHitsLoadingBreakdown());
    } else {
      widgets.push(
        Widgets.sortBySelectorWidget(sortByIndices),
        this._infiniteHitsWidget(this._currentUser)
      );
    }
  },

  _infiniteHitsWidget(currentUser) {
    return instantsearch.widgets.infiniteHits({
      container: '#product-approvals-result',
      cssClasses: {
        root: 'ais-Hits',
        list: 'ais-Hits-list list-view grid items borders section-shadow ',
        item: 'item'
      },
      transformItems(items) {
        items.map(function (item) {
          item.evaluationsCompletedClass = item.evaluation_status['total'] == item.evaluation_status['submitted'] ? 'primary' : '';
          item.isDeveloper = currentUser.company_id == item.developer_id;
          item.isSupplier = currentUser.company_id == item.supplier_id;
          item.isDraft = item.state == 'draft';
          item.isSubmitted = item.state == 'submitted';
          item.isApproved = item.state == 'approved';
          item.isRejected = item.state == 'rejected';
          item.isUnderReview = item.state == 'under_review';
          item.isEvaluationSupervisor = item.isDeveloper && ((item.evaluation_supervisor !== undefined && currentUser.id == item.evaluation_supervisor.id) || currentUser.company_admin);
          item.canAssignEvaluators = (item.state == 'submitted' || item.state == 'under_review') && item.isEvaluationSupervisor;
          item.canCommunicateDecision = (item.state == 'under_review') && item.isEvaluationSupervisor;
          return item;
        });
        return items;
      },
      templates: {
        item: $('#product-set-template').text(),
        empty: $('#no-search-results-found-template').text()
      }
    });
  }
};
